import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router'
import App from './App';
import AsinPage from './Asin-page';
import './index.css';

window.ReactDOMServer = require('react-dom/server');
window.ReactDOMComponentTree = require('react/lib/ReactDOMComponentTree');

ReactDOM.render((
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <Route path="/asin/:asin" component={AsinPage}/>
    </Route>
  </Router>
), document.getElementById('root'))




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/